import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, Waves } from 'lucide-react';
import { programs, issaBadgeSquare } from '../data/mock';
import { groupMembership as g } from '../data/programDetails';
import StackedHero from '../components/programs/StackedHero';
import PricingTableSection from '../components/programs/PricingTableSection';

const group = programs[0];

function IssaBand() {
  return (
    <section className="pt-4" data-testid="group-issa-band">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white rounded-3xl border border-splash-sand p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 md:gap-10 shadow-sm">
          <img src={issaBadgeSquare} alt="ISSA Accredited Swim School" loading="lazy" decoding="async" className="w-28 h-28 object-contain shrink-0" />
          <div className="flex-1 text-center md:text-left">
            <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-2">Nationally Accredited</div>
            <h2 className="font-display font-bold text-2xl md:text-3xl text-splash-green leading-tight">Proud ISSA Accredited Swim School</h2>
            <p className="mt-2 text-splash-green/80 leading-relaxed max-w-2xl">
              Little Splash meets the International Swimming Schools Association&rsquo;s standards for safety, curriculum, and instructor training.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function GroupMembership() {
  return (
    <main data-testid="group-membership-page">
      <StackedHero image={group.image} alt={group.title} position={group.imagePosition || 'center 30%'} eyebrow={`Ages ${g.ages} · Monthly Membership`} title="Group Membership">
        <p className="mt-6 text-splash-green/80 text-lg leading-relaxed">{g.lead}</p>
        <ul className="mt-6 grid sm:grid-cols-2 gap-3">
          {g.facts.map((f) => <li key={f} className="flex gap-2 text-splash-green/85"><Check className="w-5 h-5 text-splash-teal shrink-0 mt-0.5" /> {f}</li>)}
        </ul>
      </StackedHero>
      <IssaBand />
      <PricingTableSection />
      <section className="pb-20" data-testid="group-assessment-widget">
        <div className="max-w-4xl mx-auto px-6">
          <div className="rounded-3xl bg-splash-creamDark border border-splash-sand p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6">
            <div className="shrink-0 w-14 h-14 rounded-full bg-splash-teal text-white grid place-items-center"><Waves className="w-7 h-7" /></div>
            <div className="flex-1">
              <div className="text-xs uppercase tracking-widest text-splash-coral font-semibold">Not sure where to start?</div>
              <h2 className="mt-1 font-display font-bold text-2xl md:text-3xl text-splash-green">Book a swim assessment</h2>
              <p className="mt-2 text-splash-green/80">A 20-minute, one-on-one session with Coach Abrie to see where your swimmer is and place them in the right class. <strong className="text-splash-green">$25.</strong></p>
            </div>
            <Link to="/book?type=assessment" data-testid="group-book-assessment-btn" className="inline-flex items-center justify-center gap-2 rounded-full bg-splash-coral hover:bg-splash-coralDark text-white px-7 py-3.5 font-semibold btn-transition whitespace-nowrap">
              Book assessment <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
